export default "__VITE_PUBLIC_ASSET__9fe9864d__"